import { render, staticRenderFns } from "./setDevInfo.vue?vue&type=template&id=75566e5c&scoped=true&"
import script from "./setDevInfo.vue?vue&type=script&lang=js&"
export * from "./setDevInfo.vue?vue&type=script&lang=js&"
import style0 from "./setDevInfo.vue?vue&type=style&index=0&id=75566e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75566e5c",
  null
  
)

export default component.exports